var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-row",
    { staticClass: "p-0 m-0", staticStyle: { display: "inline-flex" } },
    [
      _c(
        "b-col",
        { staticClass: "p-0 m-0" },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c(
                    "b-overlay",
                    {
                      attrs: {
                        show: _vm.consultando,
                        rounded: "sm",
                        "spinner-small": "",
                      },
                    },
                    [
                      _c(
                        "b-dropdown",
                        {
                          directives: [
                            {
                              name: "b-tooltip",
                              rawName: "v-b-tooltip.hover",
                              value: _vm.$t(
                                "apeironGwApp.pdfsSolicitudPosgrado.verReportes"
                              ),
                              expression:
                                "$t('apeironGwApp.pdfsSolicitudPosgrado.verReportes')",
                              modifiers: { hover: true },
                            },
                          ],
                          staticClass: "mx-1",
                          attrs: {
                            name: "dropdown-left",
                            variant: "primary",
                            disabled: _vm.consultando,
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "button-content",
                              fn: function () {
                                return [
                                  _c("span", {
                                    domProps: {
                                      textContent: _vm._s(
                                        _vm.$t(
                                          "apeironGwApp.pdfsSolicitudPosgrado.pdfsSolicitud"
                                        )
                                      ),
                                    },
                                  }),
                                  _vm._v(" "),
                                  !_vm.consultando
                                    ? _c("b-icon", {
                                        attrs: {
                                          icon: "file-pdf",
                                          variant: "primary",
                                        },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.consultando
                                    ? _c("b-icon", {
                                        attrs: {
                                          icon: "file-earmark-arrow-down",
                                          variant: "primary",
                                        },
                                      })
                                    : _vm._e(),
                                ]
                              },
                              proxy: true,
                            },
                          ]),
                        },
                        [
                          _vm._v(" "),
                          _c(
                            "b-dropdown-item",
                            {
                              attrs: { href: "javascript:void(0)" },
                              on: {
                                click: function ($event) {
                                  return _vm.generarPdfSolicitudPosgrado()
                                },
                              },
                            },
                            [
                              _c("span", {
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.$t(
                                      "apeironGwApp.pdfsSolicitudPosgrado.reportes.reporteSolicitud"
                                    )
                                  ),
                                },
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _vm.mostrarCartaRechazo
                            ? _c(
                                "b-dropdown-item",
                                {
                                  attrs: { href: "javascript:void(0)" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.generarReporteCartaRechazoPdf()
                                    },
                                  },
                                },
                                [
                                  _c("span", {
                                    domProps: {
                                      textContent: _vm._s(
                                        _vm.$t(
                                          "apeironGwApp.pdfsSolicitudPosgrado.reportes.cartaRechazo"
                                        )
                                      ),
                                    },
                                  }),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "b-dropdown-item",
                            {
                              attrs: { href: "javascript:void(0)" },
                              on: {
                                click: function ($event) {
                                  return _vm.generarReporteProfesoresConAlumnosPdf()
                                },
                              },
                            },
                            [
                              _c("span", {
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.$t(
                                      "apeironGwApp.pdfsSolicitudPosgrado.reportes.profesoresConAlumnos"
                                    )
                                  ),
                                },
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-dropdown-item",
                            {
                              attrs: { href: "javascript:void(0)" },
                              on: {
                                click: function ($event) {
                                  return _vm.generarReporteAlumnosPorGeneracionPdf()
                                },
                              },
                            },
                            [
                              _c("span", {
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.$t(
                                      "apeironGwApp.pdfsSolicitudPosgrado.reportes.alumnosPorGeneracion"
                                    )
                                  ),
                                },
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _vm.solicitud.documentoFormalizacion?.url ?? undefined
                            ? _c(
                                "b-dropdown-item",
                                {
                                  attrs: { href: "javascript:void(0)" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.generarDocumentoPorUrl(
                                        _vm.solicitud.documentoFormalizacion
                                          ?.url ?? undefined
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("span", {
                                    domProps: {
                                      textContent: _vm._s(
                                        _vm.$t(
                                          "apeironGwApp.pdfsSolicitudPosgrado.reportes.documentoFormalizacionDictaminadora"
                                        )
                                      ),
                                    },
                                  }),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.solicitud.documentoFormalizacionReconsideracion
                            ?.url ?? undefined
                            ? _c(
                                "b-dropdown-item",
                                {
                                  attrs: { href: "javascript:void(0)" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.generarDocumentoPorUrl(
                                        _vm.solicitud
                                          .documentoFormalizacionReconsideracion
                                          ?.url ?? undefined
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("span", {
                                    domProps: {
                                      textContent: _vm._s(
                                        _vm.$t(
                                          "apeironGwApp.pdfsSolicitudPosgrado.reportes.documentoFormalizacionReconsideracion"
                                        )
                                      ),
                                    },
                                  }),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.mostrarDocumentoDeReplica
                            ? _c(
                                "b-dropdown-item",
                                {
                                  attrs: { href: "javascript:void(0)" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.generarDocumentoPorUrl(
                                        _vm.solicitud.solicitudReplica
                                          ?.urlDocumento ?? undefined
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("span", {
                                    domProps: {
                                      textContent: _vm._s(
                                        _vm.$t(
                                          "apeironGwApp.pdfsSolicitudPosgrado.reportes.documentoDeReplica"
                                        )
                                      ),
                                    },
                                  }),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c(
                    "b-modal",
                    {
                      attrs: { name: "modal-pdfs", size: "xl" },
                      scopedSlots: _vm._u([
                        {
                          key: "modal-title",
                          fn: function () {
                            return [
                              _c("span", {
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.$t(
                                      "apeironGwApp.pdfsSolicitudPosgrado.pdfsSolicitud"
                                    )
                                  ),
                                },
                              }),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "modal-footer",
                          fn: function () {
                            return [
                              _c(
                                "b-button",
                                {
                                  staticClass: "mt-3",
                                  attrs: { variant: "secondary" },
                                  on: {
                                    click: function ($event) {
                                      _vm.mostrarPdf = false
                                    },
                                  },
                                },
                                [
                                  _c("span", {
                                    domProps: {
                                      textContent: _vm._s(
                                        _vm.$t(
                                          "apeironGwApp.pdfsSolicitudPosgrado.acciones.cerrar"
                                        )
                                      ),
                                    },
                                  }),
                                ]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                      model: {
                        value: _vm.mostrarPdf,
                        callback: function ($$v) {
                          _vm.mostrarPdf = $$v
                        },
                        expression: "mostrarPdf",
                      },
                    },
                    [
                      _vm._v(" "),
                      _vm.urlActual
                        ? _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { staticClass: "text-center" },
                                [
                                  _c(
                                    "b-link",
                                    {
                                      attrs: {
                                        href: _vm.urlActual,
                                        target: "_blank",
                                      },
                                    },
                                    [
                                      _c("span", {
                                        domProps: {
                                          textContent: _vm._s(_vm.urlActual),
                                        },
                                      }),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c("b-col", [
                            _c("embed", {
                              attrs: {
                                src: _vm.contenidoBase64,
                                type: "application/pdf",
                                width: "100%",
                                height: "600",
                                frameborder: "0",
                              },
                            }),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }